import type { FC } from 'react'
import styled from 'styled-components'

import { AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import H2 from '@/components/H2'
import type { SupportContact } from '@/lib/apollo/query/get-applicant'

import ActionsPanel from './ActionsPanel'
import RerunCreditChecks from './RerunCreditChecks'
import ResetSectionPanel from './ResetSectionPanel'
import { SupportContactsPanel } from './SupportContactsPanel'

const ContentContainer = styled.div`
  display: grid;
  gap: 40px;
`

const SubjectDataRequest = styled.textarea`
  min-height: 90px;
`

export interface AgentDetails {
  contactName: string
  phoneNumber: string
}

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  supportContacts?: SupportContact[]
  onClose: () => void
}

const DeveloperSidePanel: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  supportContacts,
  onClose,
}) => {
  return (
    <SlideInSidebar
      onClose={onClose}
      header={<H2>Developer Tools</H2>}
      content={
        <ContentContainer>
          <SubjectDataRequest readOnly>
            {JSON.stringify(
              {
                customerId: `${customerId}`,
                applicationId: `${applicationId}`,
                subjectId: `${subjectId}`,
              },
              null,
              4,
            )}
          </SubjectDataRequest>
          <ActionsPanel
            customerId={customerId}
            applicationId={applicationId}
            subjectId={subjectId}
          />
          <RerunCreditChecks customerId={customerId} subjectId={subjectId} />
          {supportContacts !== undefined && (
            <SupportContactsPanel supportContacts={supportContacts} />
          )}
          <ResetSectionPanel
            customerId={customerId}
            applicationId={applicationId}
            subjectId={subjectId}
          />
        </ContentContainer>
      }
      footer={
        <div className="side-by-side-flex-end">
          <AlternateButton onClick={onClose}>Cancel</AlternateButton>
        </div>
      }
    />
  )
}

export default DeveloperSidePanel
